import React from 'react';
import { useUpcomingEvents } from '../hooks/useUpcomingEvents';
import UpcomingEventCard from './UpcomingEventCard';
import '../styles/UpcomingEvents.css';

const UpcomingEvents = () => {
  const { upcomingEvents, loading } = useUpcomingEvents();

  if (loading) {
    return null;
  }

  if (!upcomingEvents || !upcomingEvents.length) {
    return null;
  }

  return (
    <section id="upcoming-events" className="upcoming-events">
      <div className="section-content">
        <h2>Events</h2>
        <div className="events-grid">
          {upcomingEvents.map((event) => (
            <UpcomingEventCard 
              key={event.event_id}
              event={event}
              pulseDateTime={event.isWithinWeek} // Add pulse effect for events within a week
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
